<template>
  <div class="w-100 h-100">
    <iframe
      :src="pointCloudUrl"
      class="w-100 h-100"
      v-if="pointCloudUrl"
      @load="$emit('toggle-spinner', false)"
    />
    <div class="col py-5 text-center" v-else>No data available</div>
    <button class="btn btn-fab btn-primary shadow" @click="addUrl()">
      <i class="fas fa-pencil-alt" v-if="pointCloudUrl" />
      <i class="fas fa-plus" v-else />
    </button>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "component-site-point-cloud",
  props: ["data", "siteId"],
  data() {
    return {
      pointCloudUrl: "",
    };
  },
  methods: {
    async addUrl() {
      this.isAddingUrl = true;

      const { value: url } = await Swal.fire({
        icon: "info",
        title: "<h5 class='mb-0'>Enter Point Cloud URL</h5>",
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Save",
        input: "text",
        inputValue: this.pointCloudUrl,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-primary mx-1",
          cancelButton: "btn btn-secondary mx-1",
          input: "text-default-dark",
        },
      });

      if (url) {
        this.$emit("toggle-spinner", true);

        const body = {
          url: url,
          site: this.siteId,
        };

        let method = "post";
        let endpoint = "point-clouds";

        if (this.data) {
          method = "put";

          endpoint += `/${this.data._id}`;
        }

        const [call, err] = await this.Helper.handle(
          this.API[method](endpoint, body)
        );

        if (!err && call.status == 200) {
          this.pointCloudUrl = url;

          this.$emit("update-site-data", {
            field: "point_cloud",
            data: call.data,
          });

          this.$emit("toggle-spinner", false);
        }
      }
    },
  },
  mounted() {
    if (this.data && this.data.url) {
      this.$emit("toggle-spinner", true);

      this.API.testExternal(this.data.url)
        .then(() => {
          this.pointCloudUrl = this.data.url;
        })
        .catch(() => {
          this.pointCloudUrl = "";

          this.$emit("toggle-spinner", false);

          console.error(`Invalid Point Cloud URL: ${this.data.url}`);
        });
    } else {
      this.pointCloudUrl = "";
    }
  },
};
</script>